module.exports = __webpack_public_path__ + "static/media/download_icon.0590cde6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/download_icon.png
// module id = 30
// module chunks = 0